module.exports = __webpack_public_path__ + "static/media/two-kids-chef-hats.43a22fe3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/two-kids-chef-hats.jpg
// module id = 815
// module chunks = 0